// Pre-built demo scenarios for screencast recording and AI agent playback
// Each scenario is an async function that uses the FlowstockDemoAPI

import type { FlowstockDemoAPI } from './DemoController';

async function browseCatalog(api: FlowstockDemoAPI): Promise<void> {
  api.step('Navigate to provider catalog');
  api.navigate('/provider/catalog');
  await api.wait(1500);

  api.step('Search for Nike products');
  await api.type('input[placeholder*="Search"]', 'Nike', { clear: true, delay: 80 });
  await api.wait(2000);

  api.step('Clear search');
  await api.type('input[placeholder*="Search"]', '', { clear: true });
  await api.wait(1000);

  api.step('Browse catalog complete');
}

async function merchantDashboard(api: FlowstockDemoAPI): Promise<void> {
  api.step('Navigate to merchant dashboard');
  api.navigate('/dashboard');
  await api.wait(2000);

  api.step('View dashboard content');
  api.scrollTo('.App');
  await api.wait(1500);

  api.step('Dashboard tour complete');
}

async function providerOrders(api: FlowstockDemoAPI): Promise<void> {
  api.step('Navigate to provider orders');
  api.navigate('/provider/orders');
  await api.wait(2000);

  api.step('View order stats');
  await api.wait(1500);

  api.step('Navigate to orders list');
  api.navigate('/provider/orders/list');
  await api.wait(2000);

  api.step('Orders overview complete');
}

async function providerMerchants(api: FlowstockDemoAPI): Promise<void> {
  api.step('Navigate to provider merchants');
  api.navigate('/provider/merchants');
  await api.wait(2000);

  api.step('View merchant connections');
  await api.wait(1500);

  api.step('Provider merchants tour complete');
}

export const demoScenarios: Record<string, (api: FlowstockDemoAPI) => Promise<void>> = {
  'browse-catalog': browseCatalog,
  'merchant-dashboard': merchantDashboard,
  'provider-orders': providerOrders,
  'provider-merchants': providerMerchants,
};
